import { render, staticRenderFns } from "./DeleteThematicDialog.vue?vue&type=template&id=59b8fa26&"
import script from "./DeleteThematicDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteThematicDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports